import { Component, OnInit } from '@angular/core';
import { MainService } from '../../_services/main.service';
import { SettingsService } from '../../_services/settings.service';

@Component({
  selector: 'app-license-plates',
  templateUrl: './license-plates.component.html',
  styleUrls: ['./license-plates.component.scss']
})
export class LicensePlatesComponent implements OnInit {

  constructor(
    public mainService: MainService,
    public settingsService: SettingsService
  ) { }

  ngOnInit() {
  }

}
